import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

export const PageLoader = () => (
  <Box justifyContent="center" alignItems="center" display="flex" height="100%">
    <CircularProgress />
  </Box>
);
